export const workGroupKeys = {
    WORK_GROUP_CREATE: 'workGroup/create',
    WORK_GROUP_UPDATE: 'workGroup/edit',
    WORK_GROUP_DELETE: 'workGroup/delete',
    WORK_GROUP_READ: 'workGroup/read'
};